import { AXIOS, CallbackErrorAxios, CallbackWarningAxios, CommonGlobalService } from '@umanforge/common';
import { AxiosError, AxiosResponse } from 'axios';
import { Dispatch } from '@reduxjs/toolkit';
import { API } from 'constants/api.constant';
import { GlobalService } from 'services/global.service';
import {
  ExtractionSavedView,
  ExtractionSavedViewInput,
  ExtractionSavedViewUpdate,
} from '../interfaces/extractionSavedView.interface';

export class ExtractionSavedViewService {

  static list = (
    dataType: 'filters' | 'columns',
    token: string | null,
    dispatch: Dispatch,
    onError?: CallbackErrorAxios,
    onWarning?: CallbackWarningAxios
  ): Promise<ExtractionSavedView[]> => {
    return new Promise( async resolve => {
      AXIOS.get( `${API.EXTRACTION_SAVED_VIEWS}`, {
        ...( await CommonGlobalService.getHeaderRequest( token ) ),
        params: { dataType },
      } )
        .then( ( response: AxiosResponse<ExtractionSavedView[]> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );

          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }

          resolve( response.data );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
          resolve( [] );
        } );
    } );
  };

  static create = (
    payload: ExtractionSavedViewInput,
    token: string | null,
    dispatch: Dispatch,
    onError?: CallbackErrorAxios,
    onWarning?: CallbackWarningAxios
  ): Promise<{ id: string | null }> => {
    return new Promise( async resolve => {
      AXIOS.post( `${API.EXTRACTION_SAVED_VIEWS}`, payload, {
        ...( await CommonGlobalService.getHeaderRequest( token ) ),
      } )
        .then( ( response: AxiosResponse<{ id: string | null }> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );

          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }

          resolve( response.data );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
          resolve( { id: null } );
        } );
    } );
  };

  static update = (
    id: string,
    payload: ExtractionSavedViewUpdate,
    token: string | null,
    dispatch: Dispatch,
    onError?: CallbackErrorAxios,
    onWarning?: CallbackWarningAxios
  ): Promise<boolean> => {
    return new Promise( async resolve => {
      AXIOS.put( `${API.EXTRACTION_SAVED_VIEWS}/${id}`, payload, {
        ...( await CommonGlobalService.getHeaderRequest( token ) ),
      } )
        .then( ( response: AxiosResponse<void> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );

          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }

          resolve( true );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
          resolve( false );
        } );
    } );
  };

  static delete = (
    id: string,
    token: string | null,
    dispatch: Dispatch,
    onError?: CallbackErrorAxios,
    onWarning?: CallbackWarningAxios
  ): Promise<boolean> => {
    return new Promise( async resolve => {
      AXIOS.delete( `${API.EXTRACTION_SAVED_VIEWS}/${id}`, {
        ...( await CommonGlobalService.getHeaderRequest( token ) ),
      } )
        .then( ( response: AxiosResponse<void> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );

          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }

          resolve( true );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
          resolve( false );
        } );
    } );
  };

}
